import React, { memo, useCallback } from 'react'
import type { Image } from './types'
import { getImageUrl, isVideo } from './get-image-url'
import { BgPictureContainer, MainImageContainer, MainImage, VirtualTourWrapper } from './styles'
import VirtualTourTag from '../../../common/virtual-tour-tag'
import { VirtualTourPosition } from '../../constants'
import { pageTypeEventCategories } from '../../../../services/analytics-service/categories'

interface MainImageComponentProps {
    image: Image
    handleImageClick: (index: number) => void
    index: number
    imageBorder?: string
    imageBorderRadius?: string
    showVirtualTourTag?: boolean
}

const MainImageComponent: React.FC<MainImageComponentProps> = ({
    image,
    handleImageClick,
    index,
    imageBorder,
    imageBorderRadius,
}) => {
    const imageUrls = {
        small: getImageUrl('small-mobile', image),
        medium: getImageUrl('medium-mobile', image),
        large: getImageUrl('large-mobile', image),
        desktop: getImageUrl('desktop', image),
        wideScreen: getImageUrl('wide-screen', image),
    }

    const showVirtualTourTag = isVideo(image)
    const handleClick = useCallback(() => {
        handleImageClick(index)
    }, [index, handleImageClick])

    return (
        <MainImageContainer onClick={handleClick} imageBorder={imageBorder} imageBorderRadius={imageBorderRadius}>
            <BgPictureContainer>
                {imageUrls.wideScreen && <source media="(min-width:1024px)" srcSet={imageUrls.wideScreen} />}
                {imageUrls.desktop && <source media="(min-width:640px)" srcSet={imageUrls.desktop} />}
                {imageUrls.large && <source media="(min-width:480px)" srcSet={imageUrls.large} />}
                {imageUrls.medium && <source media="(min-width:320px)" srcSet={imageUrls.medium} />}
                {imageUrls.small && (
                    <MainImage
                        alt={image.caption}
                        src={imageUrls.small}
                        imageBorder={imageBorder}
                        imageBorderRadius={imageBorderRadius}
                        loading="eager"
                        decoding="sync"
                        fetchPriority="high"
                    />
                )}
            </BgPictureContainer>
            {showVirtualTourTag && (
                <VirtualTourWrapper>
                    <VirtualTourTag
                        analyticsCategory={pageTypeEventCategories.PROPERTY_DETAILS_PAGE}
                        analyticsLabel={VirtualTourPosition.PDP_GALLERY}
                    />
                </VirtualTourWrapper>
            )}
        </MainImageContainer>
    )
}

export default memo(MainImageComponent)
